import environment from '@environment';
import { MakePaymentPayloadDTO } from 'core/models/account/make-payment-payload.dto';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';
import { PayAtExternalResponse } from './payment-pay-at-link';

export class DirectLinkPaymentService implements PaymentService<MakePaymentPayloadDTO> {
  canStatusPoll = true;
  canRefetchPoll = false;
  canTimeoutPoll = false;

  MakePayment(request?: Partial<MakePaymentPayloadDTO>): Promise<PayAtExternalResponse> {
    // TODO: make this country agnostic
    return Promise.resolve({
      redirectUrl: `${environment.HOW_TO_PAY_LINK}`,
      transactionId: '',
      paymentType: '',
      target: '_blank'
    })
  }

  TokenLinks(requestBody?: any) {
    return Promise.reject(`MauPaymentService -> TokenLinks not implemented`);
  }

  PaymentStatus(country: string, transactionId: string) {
    return Promise.reject(`MauPaymentService -> PaymentStatus not implemented`);
  }

  RefetchPayment() {
    return Promise.reject('MauPaymentService -> RefetchPayment Not Implemented')
  }
}